import { useNavigate, useParams } from 'react-router-dom';
import { IClubMemberApiSearchRequest } from '../../../utils/constants/interfaces';
import { IClubMemberLookupUiState } from '../../../components/member/ClubMemberLookup/ClubMemberLookup';

const useClubMemberSearch = () => {
  const { clubMemberId } = useParams();
  const navigate = useNavigate();

  const clubMemberSelected = (
    selectedClubMemberId: string,
    searchParams: IClubMemberApiSearchRequest,
    uiState: IClubMemberLookupUiState
  ) => {
    // Safely convert both to numbers for comparison
    const currentMemberId = clubMemberId ? parseInt(clubMemberId, 10) : undefined;
    const selectedId = parseInt(selectedClubMemberId, 10);

    if (currentMemberId !== undefined && selectedId === currentMemberId) {
      return;
    }
    // Pass search parameters and UI state via navigation state so they can be restored when returning
    void navigate(`/members/${selectedId}`, {
      state: { searchParams, uiState }
    });
  };

  return {
    clubMemberId,
    clubMemberSelected
  };
};

export default useClubMemberSearch;
